import layout from '@/layout'

export default {
  path: '/operation',
  component: layout,
  redirect: '/operation/upgradeManage',
  name: 'upgradeList',
  meta: {
    title: '运营设置',
    icon: 'setting-config'
  },
  children: [
    {
      path: '/operation/upgradeManage',
      redirect: '/operation/upgradeManage/upgradeList',
      meta: {
        title: '升级管理',
        icon: 'high-light'
      },
      children: [
        {
          path: '/operation/upgradeManage/upgradeList',
          component: () => import('@/views/operation/upgradeManage/upgrade-list'),
          meta: {
            title: '升级列表',
            icon: 'view-list'
          }
        }
      ]
    },
    {
      path: '/operation/upgradeManage/upgradeChange/:id',
      component: () => import('@/views/operation/upgradeManage/upgrade-list/edit.vue'),
      meta: {
        title: '升级修改'
      }
    }
  ]
}
